// Cookie consent state — Google Consent Mode v2 compatible
export type ConsentChoice = {
  analytics: boolean;
  marketing: boolean;
  decidedAt: string;
};

const KEY = "cf_cookie_consent";

export function getConsent(): ConsentChoice | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ConsentChoice) : null;
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(): boolean {
  return getConsent()?.analytics === true;
}

export function setConsent(choice: Omit<ConsentChoice, "decidedAt">) {
  const full: ConsentChoice = { ...choice, decidedAt: new Date().toISOString() };
  try {
    localStorage.setItem(KEY, JSON.stringify(full));
  } catch {}
  // Push to Google Consent Mode
  const gtag = (window as any).gtag;
  if (typeof gtag === "function") {
    gtag("consent", "update", {
      ad_storage: choice.marketing ? "granted" : "denied",
      ad_user_data: choice.marketing ? "granted" : "denied",
      ad_personalization: choice.marketing ? "granted" : "denied",
      analytics_storage: choice.analytics ? "granted" : "denied",
    });
  }
  window.dispatchEvent(new CustomEvent("cf:consent-changed", { detail: full }));
}

export function clearConsent() {
  try {
    localStorage.removeItem(KEY);
  } catch {}
  window.dispatchEvent(new CustomEvent("cf:consent-changed", { detail: null }));
}
